import React from "react";
import moment from "moment";
import { isEmpty } from "lodash";
import {
  Button,
  Col,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  Row,
} from "reactstrap";
import ReactTable from "@dhn/components/molecules/data-table";
import Money from "../components/Money";
import ModalHeader from "@dhn/components/molecules/modal-header";

const formatDate = (date) => (date ? moment(date).format("DD-MM-YYYY") : "");

const getServiceStatus = (detail, servicesSeleted) => {
  if (detail?.wasBilled) return { label: " Facturado", disabled: true };
  if (detail?.exist) return { label: " Agregado", disabled: true };
  if (servicesSeleted?.some((service) => service?.product?.id === detail?.product?.id))
    return { label: " Seleccionado", disabled: true };
  return { label: " Facturar", disabled: false };
};

export default function ModalQuoteDetail({
  isOpen,
  quotation,
  servicesSeleted,
  onClose,
  onSelectService,
  onAddServices,
}) {
  return (
    <Modal isOpen={isOpen} toggle={onClose} size="xl" centered>
      <ModalHeader
        toggle={onClose}
        iconClass="fa-file-text-o"
        description="Detalle de cotización"
        subtitle="Seleccione los servicios de la cotización que desea agregar."
      />
      <ModalBody>
        <Row form className="mb-4">
          <Col>
            <Label>Cotización:</Label>
            <Input value={quotation?.code || ""} disabled />
          </Col>
          <Col>
            <Label>Fecha:</Label>
            <Input value={formatDate(quotation?.date)} disabled />
          </Col>
          <Col>
            <Label>Vencimiento:</Label>
            <Input value={formatDate(quotation?.expirationDate)} disabled />
          </Col>
        </Row>
        <ReactTable
          data={quotation?.quotationsDetails || []}
          defaultPageSize={5}
          noDataText="No hay servicios en la cotización"
          className="-striped -highlight"
          columns={[
            {
              Header: "Servicio",
              minWidth: 300,
              Cell: ({ original }) => (
                <span className="text-truncate" title={original?.product?.name}>
                  {original?.product?.name}
                </span>
              ),
            },
            {
              Header: "Cantidad",
              className: "text-right",
              Cell: ({ original }) => original?.availableQuantity || 0,
            },
            {
              Header: "Tarifa",
              className: "text-right",
              Cell: ({ original }) => <Money value={original?.consultoryFee} />,
            },
            {
              Header: "Cobertura",
              className: "text-right",
              Cell: ({ original }) => <Money value={original?.insuredCoverage} />,
            },
            {
              Header: "Diferencia",
              className: "text-right",
              Cell: ({ original }) => (
                <Money value={original?.consultoryDifferent} />
              ),
            },
            {
              Header: "Valor",
              className: "text-right",
              Cell: ({ original }) => (
                <Money
                  value={
                    (Number(original?.consultoryDifferent) || 0) *
                    (Number(original?.availableQuantity) || 0)
                  }
                />
              ),
            },
            {
              Header: "Opciones",
              className: "text-center",
              Cell: ({ original }) => {
                const status = getServiceStatus(original, servicesSeleted);
                return (
                  <Button
                    type="button"
                    color={status.disabled ? "secondary" : "success"}
                    className={`${status.disabled ? "" : "btn-color-success"} card-header-action`}
                    disabled={status.disabled}
                    onClick={() => onSelectService(original)}
                  >
                    <i className="fa fa-credit-card" aria-hidden="true" />
                    {status.label}
                  </Button>
                );
              },
            },
          ]}
        />
      </ModalBody>
      <ModalFooter>
        <Button
          color="primary"
          type="button"
          className="btn-color-primary"
          disabled={isEmpty(servicesSeleted)}
          onClick={onAddServices}
        >
          <i className="fa fa-plus" aria-hidden="true" />
          {" Agregar Servicios"}
        </Button>
        <Button
          type="button"
          color="danger"
          className="btn-color-danger"
          onClick={onClose}
        >
          <i className="fa fa-times" aria-hidden="true" />
          {" Cancelar"}
        </Button>
      </ModalFooter>
    </Modal>
  );
}
